import { render, staticRenderFns } from "./autopay_midtrans.vue?vue&type=template&id=67cbd30a&"
import script from "./autopay_midtrans.vue?vue&type=script&lang=js&"
export * from "./autopay_midtrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports